
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-create_new_folder",
  "use": "icon-material-create_new_folder-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-create_new_folder\"><path d=\"M549.52-314.98h62.87v-92.03h92.63V-470h-92.63v-92.39h-62.87v92.27h-92.63v62.99h92.63zM142.15-154.02q-27.6 0-47.86-20.77-20.27-20.76-20.27-47.36v-515.7q0-26.7 20.27-47.53 20.26-20.84 47.86-20.84h276.22L481-743.35h336.85q26.7 0 47.53 20.77 20.84 20.76 20.84 47.36v453.07q0 26.6-20.84 47.36-20.83 20.77-47.53 20.77zm0-68.13h675.7v-453.07h-365.2l-62.63-62.63H142.15zm0 0v-515.7z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-create_new_folder"/>
                </svg>
            );
        };

        Icon.id = "icon-material-create_new_folder";

        export default Icon;
    